export default {
  search_comment_count:'評論',
  search_last_updated:'最新更新：',
  search_all_search:'全部搜索',
  search_little_video:'小視頻',
  search_follow_count:'關註數',
  search_special_subject:'專題',
  search_invitation:'帖子',
  search_post:'貼子',
  search_search_word_after:'關於「{searchWordAfter}」的搜索結果',
  search_open_time:'開課時間：',
  search_score:"{score}分",
  search_pic_num:'共{smallImgList}張圖片'
}
